export const getAccessor = (row) => {
  return row?.fullDescription === undefined ? row?.articleDescription : row?.fullDescription;
};
